import { render, staticRenderFns } from "./OutboxContactInfoForm.vue?vue&type=template&id=62c16bee&scoped=true"
import script from "./OutboxContactInfoForm.vue?vue&type=script&lang=js"
export * from "./OutboxContactInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c16bee",
  null
  
)

export default component.exports